import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const services = [
  {
    image: "/images/el.svg",
    title: "Groepenkast vervangen",
    href: "/groepenkast-vervangen",
  },
  {
    image: "/images/kookgroep.svg",
    title: "Kookgroep aansluiten",
    href: "/kookgroep-aansluiten",
  },
  {
    image: "/images/electric.svg",
    title: "Elektra renovatie",
    href: "/elektra-renovatie",
  },
  {
    image: "/images/meterkast.svg",
    title: "3 Fase aansluiting",
    href: "/3-fase-aansluiting",
  },
  {
    image: "/images/elektra-aanleg.svg",
    title: "Elektricien aanleggen",
    href: "/elektra-aanleggen",
  },
  {
    image: "/images/ev.svg",
    title: "Laadpaal",
    href: "/laadpaal",
  },
  {
    image: "/images/solar.svg",
    title: "Zonnepanelen",
    href: "/zonnepanelen",
  },
  {
    image: "/images/inspectie.svg",
    title: "Elektra inspectie",
    href: "/inspectie",
  },
];

function ServiceHighlights() {
  return (
    <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] pb-4 relative overflow-hidden mb-12 md:mb-16">
      <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-6">
        Waar wil je meer over weten?
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 items-center justify-center text-center">
        {services.map((service, index) => (
          <Link
            key={index}
            to={service.href}
            className="flex items-center p-6 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
          >
            <div className="w-12 h-12 flex-shrink-0 overflow-hidden rounded-lg">
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover"
              />
            </div>
            <span className="ml-4 text-[#17354A] text-lg font-medium">
              {service.title}
            </span>
            <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
          </Link>
        ))}
      </div>
    </section>
  );
}

export default ServiceHighlights;
